<template>
<div class="material">
  <div class="tab-header">
       <div
         v-for="(item,index) in tabItems"
         :class="{active: item.label == currentLabel}"
         :key="index"
         @click="tabHandle(item)"
         class="header-item meterial-self-label"
       >
          <span class="text">{{getTitle(item)}}</span>
          <span class="dot">{{getMsg(item)}}</span>
       </div>
  </div>
  <div class="tab-content">
    <img-or-voice-or-video-material
      v-show="currentLabel != 'imgText'"
      ref="imgorvoice"
      :file-type="currentLabel"
    ></img-or-voice-or-video-material>
    <img-or-text-material
      v-show="currentLabel == 'imgText'"
      @send-count="sendCount"
    ></img-or-text-material>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import imgOrTextMaterial from "./imgOrTextMaterial";
import imgOrVoiceOrVideoMaterial from "./imgOrVoiceOrVideoMaterial";
import Cookies from 'js-cookie';
export default {
  name: "index",
  components: {
    imgOrVoiceOrVideoMaterial,
    imgOrTextMaterial,
  },
  data() {
    return {
      currentLabel: 'image',
      tabItems: [
        {label: 'image',title:'图片素材',},
        {label: 'voice',title:'语音素材',},
        {label: 'video',title:'视频素材',},
        {label: 'imgText',title:'图文素材',},
      ],
      assetsCount:{
        imageCount:'',
        voiceCount:'',
        videoCount:'',
      },
      newsCount: '',
    }
  },
  created(){
    console.log('素材的',Cookies.get('appid'));
    this.getGolbalCount();
  },
  computed: {
    ...mapGetters(['selectedAppid','realMobile']),
  },
  watch: {
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.getGolbalCount();
      }
    }
  },
  methods: {
    getTitle(item){
      if(!this.realMobile){
        return item.title;
      }else {
        return item.title.slice(0,2);
      }
    },
    sendCount(newsCount){
      this.newsCount = newsCount;
    },
    tabHandle(item){
      this.currentLabel = item.label;
    },
    getMsg(item){
      switch (item.label){
        case 'image':
          return this.assetsCount.imageCount;
        case 'voice':
          return this.assetsCount.voiceCount;
        case 'video':
          return this.assetsCount.videoCount;
        case 'imgText':
          return this.newsCount;
      }
    },
    getGolbalCount(){
      this.$http({
        url: '/wx/manage/wxAssets/materialCount'
      }).then((data) => {
        if (data.code == 200) {
          this.assetsCount = data.data;
          let totalCount = this.assetsCount.imageCount + this.assetsCount.voiceCount + this.assetsCount.videoCount + this.assetsCount.newsCount;
          this.$emit('send-total-msg',totalCount);
        } else if(data.code !== 400) {
          this.$message.error(data.msg);
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";
.tab-header {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
}
.material {
  padding: 0 20px;
  margin-top: 20px;
  .header-item {
    height: 38px;
    border-radius: 19px;
    background-color: #F5F5F5;
    margin-right: 20px;
    padding: 0 19px;
    cursor: pointer;
    margin-bottom: 10px;
    .dot {
      background-color: #ffffff;
      color: #6B6C7B;
      font-size: 12px;
    }
    &.active {
      background-color: $themeColor;
      .text {
        color: #ffffff;
      }
      .dot {
        color: $themeColor;
      }
    }
  }
  .tab-content {
    padding-top: 10px;
  }
}

//移动端
@media screen and (max-width: 768px) {
  .material {
    padding: 0 10px;
    .card-item {

    }
    .tab-header {
      flex-wrap: nowrap;
    }
    .header-item {
      padding: 0 8px;
      margin-right: 10px;
      white-space: nowrap;
    }
  }
}
</style>
<style lang="scss">
.list-outer-material {
  .card-item {
    margin: 0 10px 10px 0;
    .add-card-item-inner {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;

      .icon-box {
        width: 32px;
        height: 32px;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        color: #ffffff;
      }
    }
  }
}
//移动端
@media screen and (max-width: 768px) {
  .material {
    .card-item, {
      width: 100%;
    }
    .card-item-new {
      width: 100%;
      &.add-card-item {
        width: 100%;
      }
    }
  }
}
//pc端
@media screen and (min-width: 768px) {
  .material {
    .card-item {
      float: left;
      width: 170px;
    }
    .card-item-new {
      width: 193px;
      &.add-card-item {
        height: 90px;
        width: 193px;
      }
    }
  }
}

</style>
